export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  areas: [],
  entity: 'area',
  entities: 'areas',
  prefixRouter: 'dweller.meetings'
})



// WEBPACK FOOTER //
// ./src/app/dweller/common-area/resources/data.js